import * as React from 'react';
import { ServiceStoreContainer } from '../containers/ServiceStoreContainer.js';

const ServiceStore = /*#__PURE__*/ React.memo(()=>/*#__PURE__*/ React.createElement(ServiceStoreContainer, null)
);

export { ServiceStore };
//# sourceMappingURL=ServiceStore.js.map
